import logExternalLinkClick from "lib/ga/externalLinkClick";
import styles from './AboutBid.module.css';
import global from '../bid.module.css';
import buttons from "components/_styled/buttons.module.css";

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import { ReactNode } from "react";

type Props = {
  title: ReactNode,
  text: string,
  posts: [
   {
    _source: {
      post_id: number,
      post_title: string,
      post_date: number,
      permalink: string,
      post_content: string,
      featured_image: {
        value: {
          alt: string,
          sizes: {
            medium_large: string
          }
        }
      }
    }
   }
  ], 
  themeFormat: {
    primaryText: string,
    primary: string
  }
}

const AboutBID = ({ title, text, posts, themeFormat }: Props) => {

  const extractCreator = (text) => {
    const filteredText = text.replace(/(<([^>]+)>)/gi, "");

    return filteredText.substring(0, 250)
  }
  return (
    <div style={{ backgroundColor: themeFormat.primary, color: themeFormat.primaryText }}>
      <div className={`${styles.Container} ${global.Container}`} id="local_news">
        <h3>{title}</h3>
        <p className={styles.subHeading}>{text}</p>
        <Grid alignItems="center" justifyContent="center" container spacing={{ xs: 2, md: 3 }} columns={{ xs: 12, sm: 12, md: 12 }}>
          {posts && posts.map((post) => {
            const postSource = post._source;
            return (
              <Grid item xs={12} sm={6} md={3} key={`about-${postSource.post_id}`}>
                <a href={postSource.permalink} target="_blank">
                  <Card sx={{ boxShadow: 'none', minHeight: 215, }}>
                    <CardMedia
                      component="img"
                      sx={{ height: 200 }}
                      image={postSource.featured_image ? postSource.featured_image.value.sizes.medium_large : "images/news_1.jpg"}
                      title={postSource.featured_image ? postSource.featured_image.value.alt : "news"}
                      loading="lazy"
                    />
                    <CardContent >
                      <div className={styles.NewsTile}>
                        <h2 dangerouslySetInnerHTML={{ __html: postSource.post_title }} />
                        <h3>{new Date(postSource.post_date).toDateString()}</h3>
                        <div className={postSource.post_title.length >= 26 ? 'long' : 'short'}><p dangerouslySetInnerHTML={{ __html: extractCreator(postSource.post_content) }} /></div>
                        <p className={styles.MoreLink}>Read more</p>
                      </div>
                    </CardContent>
                  </Card>
                </a>
              </Grid>
            )
          })}
        </Grid>
        <div className={styles.ButtonContainer}>
          <a
            className={buttons.SecondaryButton}
            href="https://news.completelyretail.co.uk/"
            onClick={() => logExternalLinkClick("View news", "https://news.completelyretail.co.uk/", "news", undefined, undefined)}
          >
            View All News
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutBID;
